import { Calendar, momentLocalizer } from "react-big-calendar";
import moment from "moment";
import "moment/locale/es";
import "react-big-calendar/lib/css/react-big-calendar.css";
import "./CalendarioTurnos.css";

moment.locale("es");
const localizer = momentLocalizer(moment);

function CalendarioTurnos({ turnos }) {
  const _eventos = turnos
    .filter((t) => t.estado !== "Cancelado")
    .map((turno) => ({
      id: turno.id,
      title: `${turno.usuario?.nombre || "Clienta"} - ${turno.servicio}`,
      start: new Date(turno.fechaHora),
      end: new Date(new Date(turno.fechaHora).getTime() + 60 * 60 * 1000),
      estado: turno.estado,
    }));

  const _mensajes = {
    next: "Siguiente",
    previous: "Anterior",
    today: "Hoy",
    month: "Mes",
    week: "Semana",
    day: "Día",
    agenda: "Agenda",
    date: "Fecha",
    time: "Hora",
    event: "Turno",
    noEventsInRange: "No hay turnos en este rango",
  };

  const estiloEvento = (evento) => {
    let _color = "#c4788f";
    if (evento.estado === "Pendiente") _color = "#f57f17";
    if (evento.estado === "Confirmado") _color = "#2e7d32";
    if (evento.estado === "Completado") _color = "#1565c0";

    return {
      style: {
        backgroundColor: _color,
        borderRadius: "4px",
        border: "none",
        color: "white",
        fontSize: "0.75rem",
      },
    };
  };

  return (
    <div className="calendario-contenedor">
      <Calendar
        localizer={localizer}
        events={_eventos}
        startAccessor="start"
        endAccessor="end"
        style={{ height: 600 }}
        messages={_mensajes}
        eventPropGetter={estiloEvento}
        views={["month", "week", "day", "agenda"]}
      />
    </div>
  );
}

export default CalendarioTurnos;